/*LIBRARY*/
import { useState } from "react";

/*COMPONENT*/
import TextFieldGroup from "../common_input/TextFieldGroup";

/*REDUX*/

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const RegisterStep3Page2 = ({
  phone_number,
  phone_code, // <--- Receive from parent
  set_state, // <--- Receive helper to update state
  password,
  password2,
  onChange,
  errors,
  country,
}) => {
  const [show_password, setShowPassword] = useState(false);
  const [show_password_2, setShowPassword2] = useState(false);

  const toggleShowPassword = () => {
    setShowPassword((prevState) => !prevState);
  };

  const toggleShowPassword2 = () => {
    setShowPassword2((prevState) => !prevState);
  };

  const language = localStorage?.language ? localStorage?.language : "ina";

  return (
    <>
      <TextFieldGroup
        Title={dict["Whatsapp number"][language]}
        placeholder="81.."
        name="phone_number"
        type="phone_number"
        id="phone_number"
        value={phone_number} // This is now JUST the number (e.g. 812345)
        code={phone_code} // This is the separate code (e.g. 62)
        onChange={onChange}
        // Handle code change specifically
        onCodeChange={(newCode) => set_state({ phone_code: newCode })}
        country={country}
        error={errors?.phone_number}
      />
      <TextFieldGroup
        Title={dict["Password"][language]}
        placeholder={`${dict["Enter Your Password"][language]}`}
        isPassword={true}
        name="password"
        id="password"
        type={show_password ? "text" : "password"}
        value={password}
        onChange={onChange}
        error={errors?.password}
        toggleShowPassword={toggleShowPassword}
      />
      <TextFieldGroup
        Title={dict["Confirm password"][language]}
        placeholder={`${dict["Enter Your Password"][language]}`}
        isPassword={true}
        name="password2"
        id="password2"
        type={show_password_2 ? "text" : "password"}
        value={password2}
        onChange={onChange}
        error={errors?.password2}
        toggleShowPassword={toggleShowPassword2}
      />
    </>
  );
};

export default RegisterStep3Page2;
